// src/store/modules/config.js
const state = {
    API_URL: {
      DEMO: 'https://api-demo.whappy.it',
      FDT: 'https://api-fdt.whappy.it',
      PEOPLE: 'https://api-people.whappy.it',
      TRIVELLATO: 'https://api-trivellato.whappy.it',
      YEEA: 'https://api-yeea.whappy.it',
      AXERTA: 'https://api-axerta.whappy.it',
      CPM: 'https://api-cpm.whappy.it',
      YOUBE: 'https://api-yoube.whappy.it',
      MASTERCLASS: 'https://api-masterclass.whappy.it',
      RETAIL: 'https://api-retail.whappy.it',
      OPPO: 'https://api-oppo.whappy.it',
      AUTOMOTIVE_DEMO: 'https://api-automotive-demo.whappy.it'
    },
    rememberMe: false,
    rememberCompany: '',
    rememberEmail: '',
    currentCompany: '',
    settings: null
  };
  
  const getters = {
    getApiUrl: (state) => {
      const apiUrl = state.currentCompany ? `${state.API_URL[state.currentCompany]}/api/` : '';
      console.log("🔥 getApiUrl - currentCompany:", state.currentCompany);
      console.log("🔥 getApiUrl - API_URL usado:", apiUrl);
      return apiUrl;
    },
    getSettingAddress: (state) => (state.currentCompany ? `${state.API_URL[state.currentCompany]}/api/Setting/` : ''),
    getDriveAddress: (state) => (state.currentCompany ? `${state.API_URL[state.currentCompany]}/Drive/` : ''),
    getSettings: (state) => state.settings,
    rememberMe: (state) => state.rememberMe,
    rememberCompany: (state) => state.rememberCompany,
    rememberEmail: (state) => state.rememberEmail,
    currentCompany: (state) => state.currentCompany
  };
  const mutations = {
    setCurrentCompany: (state, company) => {
      state.currentCompany = company;
    },
    setRememberMe: (state, rememberMe) => {
      state.rememberMe = rememberMe;
    },
    setRememberCompany: (state, rememberCompany) => {
      state.rememberCompany = rememberCompany;
    },
    setRememberEmail: (state, rememberEmail) => {
      state.rememberEmail = rememberEmail;
    },
    setSettings: (state, data) => {
      state.settings = data;
    },
    resetStore: (state) => {
      if (!state.rememberMe) {
        state.rememberCompany = '';
        state.rememberEmail = '';
        state.currentCompany = '';
      }
      state.settings = null;
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations
  };
  